<template lang="pug">
  .crud
    div(v-if="has_permission")
      modal-employees(:form='form')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
            div
              h2 {{ `${customer.name || ''}` }}:
              span {{ $t('strings.description_view', {attribute: $t('strings.employees')}) }}
            div(style="display:none;")
              vm-button(type="default" icon="list")
              vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
            div
              vm-button(icon="plus" @click="addEmployee" v-if="add_customer_permission") {{ $t('strings.add') }}
              vm-tooltip(:text="$t('strings.options')" delay=".5s")
                vm-dropdown(vm-custom-content vm-trigger-click)
                  vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                      vm-icon(icon="printer-outline")
                      slot &nbsp;{{ $t('strings.print') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteCustomersConfirm" :disabled="!enabledDelete" v-if="!$auth.check('Customer')")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(multiple v-model="selected"  max-height="350px" :data="employees")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                  div
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columns" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('customers.'+ item)")
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                        vm-button(type="default" icon="funnel-outline" size="small")
                        vm-dropdown-menu(class="filters")
                          .heading.d-flex.justify-content-between
                            h4 {{ $t('strings.filters') }}
                            vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                          vm-date-picker.filter(type="daterange" :label="$t('customers.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                          .filter.d-flex
                            vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('employees.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'view_payments'") {{data[indextr][column]}}
                    slot(v-if="column == 'view_payments'")
                      toggle-button(:value="!!data[indextr][column]" @change="switchPayments(data[indextr], data[indextr][column])")
                    vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
                    slot(v-if="column == 'edit'")
                      vm-button(@click="editEmploy(data[indextr])" ) {{ $t('strings.edit') }}

            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            transition(name="enter")
              .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Employees')

export default {
  name: 'Employees',
  components: {
    ModalEmployees: () => import('@/components/modals/ModalEmployees.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    form: {},
    has_permission: true,
    add_customer_permission: true,
    view_payments: true,
    selected: [],
    columns: [
      'contact',
      'email',
      'phone',
      'view_payments',
      'edit'
    ],
    columnsOrderBy: [
      // Nota: Solo si columnas tienen atributos
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Pagado',
        value: 2,
        color: 'warning'
      }
    ],
    filters: {
      where: {
        contact: '',
        email: '',
        param: ''
      },
      whereIn: {
        status: []
      },
      whereBetween: {
        priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.checkPermissionView('customers.index')
    this.filtersClear = parseVuexObject(this.filters)
    await this.getEmployees(1, this.$route.params.customerId)
    await this.loadCustomer({ id: this.$route.params.customerId })
  },
  methods: {
    ...mapActions([
      'loadEmployees',
      'loadCustomer',
      'setModalEmployeeVisible',
      'printReport',
      'editEmployee',
      'applyFilter',
      'clearFilter'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.add_customer_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'customers.store') > -1
    },
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    addEmployee () {
      this.isModalAdd = true
      this.setModalEmployeeVisible(true)
      this.form = {
        name: this.customer.name,
        user_id: this.customer.user_id,
        id: this.customer.id,
        website: this.customer.website
      }
    },
    switchPayments (employee, flag) {
      this.form = { ...employee }
      this.form.view_payments = !flag
      this.editEmployee(this.form)
    },
    editCustomerModal (customer, index) {
      this.isModalAdd = false
      this.setModalEmployeeVisible(true)
      this.form = { ...customer }
    },
    async deleteCustomerConfirm (customer) {
      let t = this
      this.auxDeleteCustomer = () => {
        t.deleteCustomer(customer).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: this.$t(customer.contact) }),
        accept: this.auxDeleteCustomer
      })
    },
    async deleteCustomersConfirm () {
      let t = this
      let customersMany = parseDeleteMany(this.selected, 'contact')
      this.auxDeleteCustomer = () => {
        t.deleteCustomers(customersMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: customersMany.values }),
        accept: this.auxDeleteCustomer
      })
    },
    async setActionCustomer (record, action) {
      record.id && this.actionCustomer({ id: record.id, action })
    },
    async getEmployees (page, employer) {
      let t = this
      t.loadEmployees({ page: page, employer: employer })
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    editEmploy (employee) {
      console.log('employee', employee)

      this.isModalAdd = true
      this.setModalEmployeeVisible(true)
      this.isAdd = false
      this.form = {
        ...employee,
        edit: true
      }
    }
  },
  computed: {
    ...mapGetters([
      'employees',
      'customer',
      'customersCatalog',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, ${t.$t('customers.' + column)}` : `${str} ${t.$t('customers.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.customer'), columns: concatColumns, column: this.$t('customers.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getEmployees(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getEmployees(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
